import chalk from 'chalk'
import type { MutableRefObject } from 'react'

/**
 * 替换引用标识
 * @param citation 要替换的内容
 * @param reference 引用数组
 * @returns
 */
export const replaceCitation = (citation: string, reference: string[]) => {
  const number = parseInt(citation.split(':')[1])
  const index = number - 1
  if (index < reference.length) {
    return `<a href="${reference[index]}" target="_blank" rel="noopener noreferrer">${number}</a>`
  }

  return citation
}

export const sleep = (ms: number) => {
  return new Promise<void>((resolve) => setTimeout(resolve, ms))
}

export const formatTime = (beginTime: number, endTime: number) => {
  return ((endTime - beginTime) / 1000).toFixed(3)
}

export const chalkConsole = (text: string, time: number | string) => {
  return console.log(chalk.bgRedBright(text), time)
}

export const getDataByStep = (cacheList: any[], stopRef: MutableRefObject<any>) => {
  let currentIndex = 0
  return {
    next: (isClosed: boolean) => {
      // 如果是流式请求正常关闭并且缓存便利结束 || 退出AI生成
      if ((isClosed && currentIndex >= cacheList.length) || stopRef.current) {
        return {
          done: true,
          value: undefined,
        }
      }

      if (currentIndex >= cacheList.length) {
        return {
          done: false,
          value: undefined,
        }
      }

      const data = cacheList[currentIndex]
      currentIndex++
      return {
        done: false,
        value: data,
      }
    },
  }
}

/**
 * 创建一个流式迭代器
 * @param cacheList 缓存数据数组
 * @param maxStep 最大步长，默认为1
 * @returns 返回一个包含 next, markStreakClosed, 和 reset 方法的对象
 */
export const createStreamIterator = (cacheList: any[], maxStep: number = 1) => {
  let currentIndex = 0
  let isClosed = false

  // 标记流式数据已经关闭
  const markStreakClosed = () => {
    isClosed = true
  }
  // 重置迭代器
  const reset = () => {
    currentIndex = 0
    isClosed = false
  }
  // 获取下一步数据
  const next = () => {
    if (currentIndex >= cacheList.length) {
      if (isClosed) {
        return {
          done: true,
          value: undefined,
        }
      }
      return {
        done: false,
        value: undefined,
      }
    }

    const step = Math.min(maxStep, cacheList.length - currentIndex)
    const result = cacheList.slice(currentIndex, currentIndex + step)
    currentIndex += step

    return {
      done: false,
      value: result,
    }
  }

  return {
    next,
    markStreakClosed,
    reset,
  }
}
